import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import DateFormat, { TimeFormat } from 'utils/dateFormat';
import CurrencyFormat from 'utils/currencyFormat';
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import processParams from "utils/processParams";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import { BackButtonPage } from "components/__new/common/BackButton";
import * as employeesActions from "store/entities/employees/action";
import Maybe from "components/__new/common/Maybe";
import PageContent from "components/__new/common/PageContent";
import Table from "components/__new/common/Table";
import { TableContent } from "components/__new/common/TableContent";
// import Pagination from "components/__new/common/pagination";


const EraTransactions = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { id } = useParams();
    const {urlQueryParams} = useUrlQueryParams();
    const { employeeLoading, employee, transactionsLoading, transactions } = useSelector((s) => s.entities.employees);


    const [listParams, setListParams] = useState({
        "page": 1,
        "limit": 20,
        "type": "employee",
        "userId": id,
    });


    const getAllTransactions = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 20, "limit");

        setListParams(params);        
        dispatch(employeesActions.getAllTransactions(params));
    }


    useEffect(() => {
        if (id){
            dispatch(employeesActions.getEmployee(id));
            getAllTransactions();
        }
        // eslint-disable-next-line
    }, [id]);


    useEffect(() => {
        getAllTransactions();
        // eslint-disable-next-line
    }, [location]);


    return ( 
        <div>


            <DynamicHeadTag
                headerText="ERA Transactions | Employees"
                headerDescription="Manage and monitor your employees' payment activity."
            />
            

            <div className="lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title flex">
                        <BackButtonPage />
                        All Transactions
                    </div>
                </div>
                <div className="w-full lg:w-1/2 flex mt-4 lg:mt-0 lg:justify-end space-x-3"></div>
            </div>


            <div className="mt-8 xl:flex xl:space-x-4 space-y-4 xl:space-y-0">

                <div className="xl:w-72 box flex-shrink-0">
                    <PageContent
                        loading={employeeLoading}
                        data={employee}
                        loadingText="Loading employee"
                        emptyText="Employee not found yet"
                    />
                    
                    {employeeLoading === false && employee?.status === "success" && 
                        <>
                            <div className="text-2xl font-bold">
                                {employee.employee?.fullName}
                            </div>
                            <div className="mt-1">
                                {employee.employee?.email}
                            </div>
                            <div className="mt-4">
                                <Maybe condition={employee.employee?.status === "pending"}>
                                    <div className="text-sm whitespace-nowrap inline capitalize">
                                        <div className="w-3 h-3 -mt-1 mr-2 relative top-px rounded-full inline-block bg-ep-secondary"></div>
                                        Pending
                                    </div>
                                </Maybe>
                                <Maybe condition={employee.employee?.status === "active"}>
                                    <div className="text-sm whitespace-nowrap inline capitalize">
                                        <div className="w-3 h-3 -mt-1 mr-2 relative top-px rounded-full inline-block bg-green-500"></div>
                                        Enrolled
                                    </div>
                                </Maybe>
                            </div>
                            <hr className="mt-6 mb-0 xl:mb-6" />
                            <div className="space-y-4 sm:flex xl:block">
                                <div className="space-y-4 w-full sm:w-1/2 xl:w-full">
                                    <div className="hidden">
                                        <div className="font-bold">
                                            Employer’s Name
                                        </div>
                                        <div className="text-base">
                                            Lorem ipsum
                                        </div>
                                    </div>
                                    <div>
                                        <div className="font-bold">
                                            Job Title
                                        </div>
                                        <div className="text-base">
                                            {employee.employee?.jobTitle}
                                        </div>
                                    </div>
                                    <Maybe condition={employee.employee?.employeeId}>
                                        <div>
                                            <div className="font-bold">
                                                Employee ID
                                            </div>
                                            <div className="text-base">
                                                {employee.employee?.employeeId}
                                            </div>
                                        </div>
                                    </Maybe>
                                    <div>
                                        <div className="font-bold">
                                            Phone Number
                                        </div>
                                        <div className="text-base">
                                            {employee.employee?.phoneNumber}
                                        </div>
                                    </div>
                                    <div>
                                        <div className="font-bold">
                                            Net Monthly Salary
                                        </div>
                                        <div className="text-base">
                                            {CurrencyFormat(employee.employee?.netMonthlySalary)}
                                        </div>
                                    </div>
                                </div>
                                <div className="space-y-4 w-full sm:w-1/2 xl:w-full">
                                    <div>
                                        <div className="font-bold">
                                            Bank Name
                                        </div>
                                        <div className="text-base">
                                            {employee.employee?.evaBankName}
                                        </div>
                                    </div>
                                    <div>
                                        <div className="font-bold">
                                            Bank Account Name
                                        </div>
                                        <div className="text-base">
                                            {employee.employee?.evaAccountName}
                                        </div>
                                    </div>
                                    <div>
                                        <div className="font-bold">
                                            Bank Account No
                                        </div>
                                        <div className="text-base">
                                            {employee.employee?.evaAccountNumber}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>

                <div className="box box-no-padding flex-grow">
                    <Table>
                        <Table.Head>
                            <th>Date</th>
                            <th>Previous Balance</th>
                            <th>Amount</th>
                            <th>Current Balance</th>
                            <th>Description</th>
                            <th>Status</th>
                        </Table.Head>
                        <Table.Body>

                            <TableContent
                                loading={transactionsLoading}
                                loadingText="Loading transactions"
                                emptyText="No transactions yet"
                                data={transactions}
                                colspan={6}
                            />


                            {transactionsLoading === false && transactions && Object.keys(transactions).length > 0 && 
                                Object.keys(transactions).map((transaction, index) =>
                                    <tr key={index}>
                                        <td>
                                            {DateFormat(transactions[transaction].created_at, "DD-MM")}
                                            <br />
                                            at {TimeFormat(transactions[transaction].created_at)}
                                        </td>
                                        <td>
                                            <div>
                                                {CurrencyFormat(transactions[transaction].prev_balance)}
                                            </div>
                                        </td>
                                        <td>
                                            {transactions[transaction].tr_type === "CREDIT" &&
                                                <div className="font-semibold text-green-500">
                                                    + {CurrencyFormat(transactions[transaction].naira)}
                                                </div>
                                            }
                                            {transactions[transaction].tr_type === "DEBIT" &&
                                                <div className="font-semibold text-red-500">
                                                    - {CurrencyFormat(transactions[transaction].naira)}
                                                </div>
                                            }
                                        </td>
                                        <td>
                                            <div>
                                                {CurrencyFormat(transactions[transaction].curr_balance)}
                                            </div>
                                        </td>
                                        <td style={{maxWidth: "300px", whiteSpace: "normal"}}>
                                            <div>
                                                {transactions[transaction].desc}
                                            </div>
                                        </td>
                                        <td>
                                            {transactions[transaction].status === "SUCCESS" &&
                                                <div className="label label-green">
                                                    Success
                                                </div>
                                            }
                                            {transactions[transaction].status === "PENDING" &&
                                                <div className="label label-yellow">
                                                    Pending
                                                </div>
                                            }
                                            {transactions[transaction].status === "FAILED" &&
                                                <div className="label label-red">
                                                    Failed
                                                </div>
                                            }
                                        </td>
                                    </tr>
                                )
                            }

                        </Table.Body>
                    </Table>

                    {/* 
                    <Maybe condition={transactionsLoading === false && Object.keys(transactions)?.length > 0}>
                        <div className="mt-6">
                            <Pagination data={Object.keys(transactions)} />
                        </div>
                    </Maybe>
                     */}

                </div>
            </div>

        </div>
    )
}


export default EraTransactions;